import { command } from "@lookiero/messaging";
const REMOVE_UI_SETTING = "remove_ui_setting";
const removeUiSetting = ({ aggregateId }) => command({ aggregateId, name: REMOVE_UI_SETTING });
export { REMOVE_UI_SETTING, removeUiSetting };
